import React from 'react';
import PropTypes from 'prop-types';

const Skeleton = ({
  lines = 3,
  height = 'h-6',
  width = 'w-full',
  radius = 'rounded',
  customStyles = '',
}) => {
  return (
    <div
      className={`space-y-4 animate-pulse ${customStyles}`}
      data-testid="skeleton-container"
    >
      {Array.from({ length: lines }).map((_, index) => (
        <div
          key={index}
          className={`${height} ${width} bg-gray-200 ${radius}`}
          data-testid={`skeleton-line-${index}`}
        ></div>
      ))}
    </div>
  );
};

Skeleton.propTypes = {
  lines: PropTypes.number, // Number of skeleton lines to show
  height: PropTypes.string, // Height of each skeleton line
  width: PropTypes.string, // Width of each skeleton line
  radius: PropTypes.string, // Border radius (rounded corners)
  customStyles: PropTypes.string, // Any additional custom styles for the container
};

export default Skeleton;
